import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserDetailsComponent} from './user-details/user-details.component';
import {MatButtonModule} from "@angular/material/button";
import {PublicationDebugComponent} from './publication/publication-debug.component';
import {UserLocalizationDebugComponent} from './user-localization/user-localization-debug.component';
import {MatIconModule} from "@angular/material/icon";
import {FuseHighlightModule} from "../../../@fuse/components/highlight";
import {MatTabsModule} from "@angular/material/tabs";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatSelectModule} from "@angular/material/select";
import { UrlEntryComponent } from './url-entry/url-entry.component';
import { TranslocoModule } from '@ngneat/transloco';
import { EventsComponent } from './events/events.component'
import {ExtProfileDirective} from "../landing-publication/ext-profiles/types/extProfile.directive";

@NgModule({
    declarations: [
        UserDetailsComponent,
        PublicationDebugComponent,
        UserLocalizationDebugComponent,
        UrlEntryComponent,
        EventsComponent
    ],
    exports: [
        UserDetailsComponent,
        PublicationDebugComponent,
        UserLocalizationDebugComponent,
        UrlEntryComponent,
        EventsComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        FuseHighlightModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        TranslocoModule,
        ExtProfileDirective,
    ]
})
export class DebugPanelsModule {
}
